import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { VillageScene } from './scenes/VillageScene';
import { HeroScene } from './scenes/HeroScene';
import { TalentsScene } from './scenes/TalentsScene';
import { QuestsScene } from './scenes/QuestsScene';
import { SettingsScene } from './scenes/SettingsScene';
import { DungeonGateScene } from './scenes/DungeonGateScene';
import { TrainingGroundsScene } from './scenes/TrainingGroundsScene';
import { BlacksmithScene } from './scenes/BlacksmithScene';
import { ComingSoonScene } from './scenes/ComingSoonScene';
import { DebugMenuScene } from './scenes/DebugMenuScene';
import { MainMenuScene } from './scenes/MainMenuScene';
import { CombatScene } from './scenes/CombatScene';
import { DungeonResultScene } from './scenes/DungeonResultScene';

/** Design resolution: portrait phone-ish canvas. */
export const GAME_WIDTH = 390;
export const GAME_HEIGHT = 844;

export function createGameConfig(
  parent: string | HTMLElement,
): Phaser.Types.Core.GameConfig {
  return {
    type: Phaser.AUTO,
    parent,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: '#0b1020',
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [
      BootScene,
      PreloadScene,
      VillageScene,
      HeroScene,
      TalentsScene,
      QuestsScene,
      SettingsScene,
      DungeonGateScene,
      TrainingGroundsScene,
      BlacksmithScene,
      ComingSoonScene,
      DebugMenuScene,
      MainMenuScene,
      CombatScene,
      DungeonResultScene,
    ],
    render: {
      pixelArt: true,
      antialias: false,
    },
    audio: {
      noAudio: true,
    },
  };
}
